import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuildClientPayload } from "@/components/common/types/BuildClientPayload";
import fetchPatientAddressListApi from "@/redux/slice/location/apis/fetchPatientAddressList";

export default createAsyncThunk(
  "location/fetchPatientAddressList",
  async (payload: BuildClientPayload & { patientId: string }) => {
    const fetchUpdatedAddressListResponse = await fetchPatientAddressListApi(payload);

    return fetchUpdatedAddressListResponse?.data?.getPatientAddressList?.addressList;
  }
);
